import { Injectable, signal } from '@angular/core';
import type { ElementRef, Signal } from '@angular/core';
import type { AbstractControl } from '@angular/forms';

export interface EvaluationFormFieldRef {
  readonly elRef: ElementRef<HTMLElement>;
  readonly control: Signal<AbstractControl>;
}

@Injectable()
export class EvaluationFormSubmissionService {
  private readonly fieldRefs: EvaluationFormFieldRef[] = [];

  public readonly submissionAttempted = signal(false);

  public registerField(field: EvaluationFormFieldRef): void {
    this.fieldRefs.push(field);
  }

  public unregisterField(field: EvaluationFormFieldRef): void {
    const index = this.fieldRefs.indexOf(field);
    if (index > -1) this.fieldRefs.splice(index, 1);
  }

  public registerAttempt(form: AbstractControl): void {
    form.markAllAsTouched();
    this.submissionAttempted.set(true);
    this.scrollToFirstInvalidField();
  }

  public reset(): void {
    this.submissionAttempted.set(false);
  }

  private scrollToFirstInvalidField(): void {
    const [topMostInvalid] = this.fieldRefs
      .filter(field => field.control().invalid)
      .sort(
        (a, b) =>
          a.elRef.nativeElement.getBoundingClientRect().top -
          b.elRef.nativeElement.getBoundingClientRect().top,
      );

    if (!topMostInvalid) return;

    const fieldElement = topMostInvalid.elRef.nativeElement;
    const target = fieldElement.querySelector('[data-evaluation-invalid]') ?? fieldElement;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
